import NotificationsList from './NotificationsList';

export default function NotificationsAll() {
    return (
        <div className="sf-notif-page">
            <NotificationsList />
        </div>
    );
}
